import { sideTabSchema } from "@/Routes/sidebar.utility";
import { Transition } from "@headlessui/react";
import { Fragment } from "react";
import SideHref from "./SideHref";
import useRoutesHandler from "@/Hooks/useRouteHandler";
import { stringUtility } from "@repo/utilities/string.utility.ts";

const SubTabSideTabs = ({
  tabData,
  expandSidebar,
}: {
  tabData: sideTabSchema | null | undefined;
  expandSidebar: boolean;
}) => {
  //HOOKS
  const { activeRoutes } = useRoutesHandler();

  return (
    <Transition
      show
      as={Fragment}
      enter="transition-opacity duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="w-11/12 px-1 flex flex-col gap-1  border-l-2 translate-x-4 border-lightGray">
        {tabData?.subTabs?.map((subTabData) => {
          return (
            <SideHref
              key={subTabData.name}
              draggable={false}
              hrefTo={subTabData.path}
              tabData={subTabData}
              isActive={activeRoutes.includes(
                stringUtility.removeSpaceAddChar(subTabData.name, "-")
              )}
              className="pl-6 "
              expandSidebar={expandSidebar}
            />
          );
        })}
      </div>
    </Transition>
  );
};

export default SubTabSideTabs;
